import MarketPlace from "./selector";

export default MarketPlace;
